@use '@/scss/underscore' as _;
@use '@logto/core-kit/scss/console-themes' as themes;

.app {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
}

.topbarShadow {
  box-shadow: var(--shadow-2);
}
